import { GEnum } from '@/constants/enum.defination';
import i18n from '@/i18n';

export namespace GroupType {
  import GroupType = GEnum.GroupType;
  export const groupTypeName = (type: GroupType): string => {
    switch (type) {
      case GEnum.GroupType.Harmony:
        return i18n.t('FOCUS_ON_HARMONY').toString();
      case GEnum.GroupType.Diversity:
        return i18n.t('FOCUS_on_DIVERSITY').toString();
    }
  };
}
